<script setup lang="ts">
import { onMounted } from 'vue'
import { useContentStore } from '@/stores/contentStore'
import { useWebSocket } from '@/composables/useWebSocket'
import AppLayout from '@/components/layout/AppLayout.vue'

const contentStore = useContentStore()
const { onFileChange } = useWebSocket()

onMounted(() => {
  // Load initial content from API
  contentStore.loadContent()

  // Set up WebSocket listener for real-time updates
  onFileChange((message) => {
    contentStore.handleFileChange(message)
  })
})
</script>

<template>
  <div id="app">
    <div
      v-if="contentStore.isLoading"
      class="flex items-center justify-center min-h-screen bg-gray-50"
    >
      <div class="text-center">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4" />
        <p class="text-gray-600">
          Loading HQ Dashboard...
        </p>
      </div>
    </div>
    <AppLayout v-else>
      <RouterView />
    </AppLayout>
  </div>
</template>
